import WinnersFeedGrid from "@/app/(general-header)/home/winnersFeed/WinnersFeedGrid";
import { StoreProvider } from "@/app/storeProvider";
import React from "react";
import { createRoot } from "react-dom/client";

const el = document.getElementById("winners-feed-widget");
if (!el) throw new Error("Missing #winners-feed-widget");

createRoot(el).render(
  <React.StrictMode>
    <StoreProvider>
      <WinnersFeedGrid />
    </StoreProvider>
  </React.StrictMode>
);